import { ApiClient } from '@brent/shared/api'
import { userPool } from './cognito'

const apiClient = new ApiClient({
  baseUrl: import.meta.env.VITE_CA_API_BASE_URL || 'http://localhost:3000',
  timeout: 10000,
  userPool,
  onUnauthorized: () => {
    // All access now requires authentication. On 401, reload the page
    // to trigger the ProtectedRoute which will redirect to Managed Login.
    window.location.href = '/'
  },
})

export default apiClient
